<script setup lang="ts">
import { ArrowRight } from '@element-plus/icons-vue'
import WujieVue from 'wujie-vue3'

const props = defineProps<{
  data: APISdpMessage.MessageRecordDto
}>()

const { bus } = WujieVue
</script>

<template>
  <div class="bg-white p-4 rounded-lg mb-4">
    <h3 class="text-base text-n-600 font-medium">
      <i v-if="!props.data?.read" class="w-2 h-2 rounded bg-error inline-block mr-1 relative -translate-y-[2px]" />
      【{{ props.data?.messageId }}】 {{ props?.data?.content?.title }}
    </h3>
    <p class="text-n-400 text-sm mt-2 line-clamp-2">
      {{ props?.data?.content?.body }}
    </p>
    <div class="flex justify-between mt-2">
      <span class="text-n-90">{{ props.data?.sendTime }}</span>
      <el-button type="primary" link @click="bus.$emit('notice:view', props.data?.messageId)">
        查看详情 <el-icon><ArrowRight /></el-icon>
      </el-button>
    </div>
  </div>
</template>
